"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactComponents = require("@cimpress/react-components");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _emotion = require("emotion");
var _i18n = require("../../utils/i18n");
var _PriceInfo = _interopRequireDefault(require("../PriceInfo"));
var _SummaryTemplate = _interopRequireDefault(require("./SummaryTemplate"));
var _PriceModelV2Link = _interopRequireDefault(require("./PriceModelV2Link"));
var _PriceAdjustmentLink = _interopRequireDefault(require("./PriceAdjustmentLink"));
var _priceutils = require("../../utils/priceutils");
var _NoPrice = _interopRequireDefault(require("./NoPrice"));
var _Link = _interopRequireDefault(require("./Link"));
var _PriceModelV1Link = _interopRequireDefault(require("./PriceModelV1Link"));
var _ContractLink = _interopRequireDefault(require("./ContractLink"));
var _productConfiguration = require("../../apis/productConfiguration");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var priceSummaryClass = (0, _emotion.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"])));
var priceSummaryPriceClass = (0, _emotion.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex-grow: 2;\n"])));
var PriceSummary = /*#__PURE__*/function (_Component) {
  _inherits(PriceSummary, _Component);
  var _super = _createSuper(PriceSummary);
  function PriceSummary(props) {
    var _this;
    _classCallCheck(this, PriceSummary);
    _this = _super.call(this, props);
    _this.state = {
      productDetails: null
    };
    return _this;
  }
  _createClass(PriceSummary, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$props, accessToken, productConfigurationHref, productDetails;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, accessToken = _this$props.accessToken, productConfigurationHref = _this$props.productConfigurationHref;
                _context.next = 3;
                return (0, _productConfiguration.getProductDetails)(productConfigurationHref, accessToken);
              case 3:
                productDetails = _context.sent;
                this.setState({
                  productDetails: productDetails
                });
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.productConfigurationHref !== prevProps.productConfigurationHref) {
        this.componentDidMount();
      }
    }
  }, {
    key: "getLinks",
    value: function getLinks(priceIsValid, adjustmentPriceAssociations, shouldRenderCustomQuoteLink, priceExplorerHref, selections) {
      var priceLinks = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      var _this$props2 = this.props,
        locale = _this$props2.locale,
        i18n = _this$props2.i18n;
      var shouldLinksBeInline = !priceIsValid;
      var priceModelV1Link = (0, _priceutils.priceLinksContainPriceModelV1)(priceLinks) ? /*#__PURE__*/_react["default"].createElement(_PriceModelV1Link["default"], {
        key: "priceModel",
        locale: locale,
        i18n: i18n,
        links: priceLinks,
        inline: shouldLinksBeInline
      }) : null;
      var priceModelV2Link = (0, _priceutils.priceLinksContainPriceModelV2)(priceLinks) && this.state.productDetails ? /*#__PURE__*/_react["default"].createElement(_PriceModelV2Link["default"], {
        key: "priceModel",
        locale: locale,
        i18n: i18n,
        links: priceLinks,
        selections: selections,
        productDetails: this.state.productDetails
      }) : null;
      var priceModelLink = priceModelV2Link ? priceModelV2Link : priceModelV1Link;
      var contractLink = /*#__PURE__*/_react["default"].createElement(_ContractLink["default"], {
        key: "contract",
        locale: locale,
        i18n: i18n,
        links: priceLinks,
        inline: shouldLinksBeInline
      });
      return [priceModelLink, contractLink, /*#__PURE__*/_react["default"].createElement(_PriceAdjustmentLink["default"], {
        key: "priceAdjustments",
        locale: locale,
        i18n: i18n,
        priceAdjustments: adjustmentPriceAssociations,
        inline: shouldLinksBeInline
      }), shouldRenderCustomQuoteLink ? /*#__PURE__*/_react["default"].createElement(_Link["default"], {
        key: "customQuote",
        locale: locale,
        i18n: i18n,
        href: priceLinks.source.href,
        translationsKey: "view_custom_quote",
        inline: shouldLinksBeInline
      }) : null, priceExplorerHref ? /*#__PURE__*/_react["default"].createElement(_Link["default"], {
        key: "priceExplorer",
        locale: locale,
        i18n: i18n,
        href: priceExplorerHref,
        translationsKey: "view_in_price_explorer",
        inline: shouldLinksBeInline
      }) : null];
    }
  }, {
    key: "render",
    value: function render() {
      var _errors$find, _errors$find$sourceEr, _priceAssociation$pri, _priceAssociation$pri2, _priceAssociation$_em;
      var _this$props3 = this.props,
        priceTypeText = _this$props3.priceTypeText,
        i18n = _this$props3.i18n,
        locale = _this$props3.locale,
        itemId = _this$props3.itemId,
        accessToken = _this$props3.accessToken,
        priceType = _this$props3.priceType,
        repairReason = _this$props3.repairReason,
        priceInfo = _this$props3.priceInfo,
        hasPermissionForPriceRepair = _this$props3.hasPermissionForPriceRepair,
        onNewPrice = _this$props3.onNewPrice,
        useCurrencySymbol = _this$props3.useCurrencySymbol,
        priceExplorerHref = _this$props3.priceExplorerHref;
      var price = priceInfo.price,
        errors = priceInfo.errors,
        source = priceInfo.source;
      if (!price && !errors) {
        return /*#__PURE__*/_react["default"].createElement(_reactComponents.Alert, {
          message: (0, _i18n.tt)(this.props, 'diagnostics:no_price_associations_available'),
          type: 'warning',
          dismissible: false
        });
      }
      var totalAmount = priceInfo.totalAmount,
        adjustmentPriceAssociations = priceInfo.adjustmentPriceAssociations,
        priceAssociation = priceInfo.priceAssociation,
        hasConsistentCurrencies = priceInfo.hasConsistentCurrencies,
        currencies = priceInfo.currencies;
      var shouldRenderCustomQuoteLink = (0, _priceutils.isCustomPrice)(priceAssociation);

      // Prefer inputs from source error
      var inputs = (errors === null || errors === void 0 ? void 0 : (_errors$find = errors.find(function (error) {
        return error.sourceError;
      })) === null || _errors$find === void 0 ? void 0 : (_errors$find$sourceEr = _errors$find.sourceError) === null || _errors$find$sourceEr === void 0 ? void 0 : _errors$find$sourceEr.inputs) || (source === null || source === void 0 ? void 0 : source.inputs) || [];
      var selections = inputs.map(function (_ref) {
        var name = _ref.name,
          value = _ref.value,
          scope = _ref.scope;
        return {
          name: "".concat(scope === 'product' ? '' : scope).concat(name),
          value: value
        };
      });
      var priceIsValid = (0, _priceutils.isValidPrice)(price);
      var priceLinks = (_priceAssociation$pri = (_priceAssociation$pri2 = priceAssociation.price) === null || _priceAssociation$pri2 === void 0 ? void 0 : _priceAssociation$pri2._links) !== null && _priceAssociation$pri !== void 0 ? _priceAssociation$pri : (_priceAssociation$_em = priceAssociation._embedded.priceError) === null || _priceAssociation$_em === void 0 ? void 0 : _priceAssociation$_em._links;
      var links = this.getLinks(priceIsValid, adjustmentPriceAssociations, shouldRenderCustomQuoteLink, priceExplorerHref, selections, priceLinks);
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, (0, _priceutils.isValidPrice)(totalAmount) && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SummaryTemplate["default"], {
        priceTypeText: priceTypeText,
        price: totalAmount,
        links: links,
        useCurrencySymbol: useCurrencySymbol
      })), !(0, _priceutils.isValidPrice)(totalAmount) && /*#__PURE__*/_react["default"].createElement("div", {
        className: priceSummaryClass
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: priceSummaryPriceClass
      }, /*#__PURE__*/_react["default"].createElement(_NoPrice["default"], {
        links: links,
        accessToken: accessToken,
        priceTypeText: priceTypeText,
        locale: locale,
        i18n: i18n,
        itemId: itemId,
        repairReason: repairReason,
        priceType: priceType,
        hasPermissionForPriceRepair: hasPermissionForPriceRepair,
        hasConsistentCurrencies: hasConsistentCurrencies,
        currencies: currencies,
        onNewPrice: onNewPrice
      }))), /*#__PURE__*/_react["default"].createElement(_PriceInfo["default"], {
        locale: locale,
        i18n: i18n,
        inputs: inputs || [],
        errors: errors
      }));
    }
  }]);
  return PriceSummary;
}(_react.Component);
PriceSummary.propTypes = {
  priceTypeText: _propTypes["default"].string,
  locale: _propTypes["default"].string,
  priceInfo: _propTypes["default"].object.isRequired,
  i18n: _propTypes["default"].any,
  // comes from withTranslation
  accessToken: _propTypes["default"].string,
  itemId: _propTypes["default"].string,
  repairReason: _propTypes["default"].string,
  priceType: _propTypes["default"].string,
  hasPermissionForPriceRepair: _propTypes["default"].bool,
  onNewPrice: _propTypes["default"].func,
  useCurrencySymbol: _propTypes["default"].bool,
  priceExplorerHref: _propTypes["default"].string,
  productConfigurationHref: _propTypes["default"].string
};
PriceSummary.defaultProps = {
  locale: 'en'
};
var _default = (0, _reactI18next.withTranslation)()(PriceSummary);
exports["default"] = _default;